import { useEffect } from "react";

// Writes page meta into the real document <head>. Rendering <head> inside the
// React tree put these tags in <body>, where browsers and crawlers ignore them.
// Site-wide defaults from public/index.html, restored when a page omits a value
// so a previous page's tags don't linger after client-side navigation.
const defaultTitle = typeof document !== "undefined" ? document.title : "";
const defaultMeta = {};
if (typeof document !== "undefined") {
  ["title", "description", "keywords"].forEach((name) => {
    defaultMeta[name] = document.head
      .querySelector(`meta[name="${name}"]`)
      ?.getAttribute("content");
  });
}

const upsertMeta = (name, value) => {
  let meta = document.head.querySelector(`meta[name="${name}"]`);
  const content = value || defaultMeta[name];
  if (!content) {
    meta?.remove();
    return;
  }
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", name);
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
};

const upsertLink = (rel, href) => {
  let link = document.head.querySelector(`link[rel="${rel}"]`);
  if (!href) {
    link?.remove();
    return;
  }
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", rel);
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
};

const SEO = ({
  pageTitle,
  font,
  metaTitle = "",
  metaDesc = "",
  metaKeywords = "",
  canonical = "",
}) => {
  useEffect(() => {
    // metaTitle is the descriptive, search-facing title; pageTitle is a short fallback
    document.title = metaTitle || pageTitle || defaultTitle;
    upsertMeta("title", metaTitle);
    upsertMeta("description", metaDesc);
    upsertMeta("keywords", metaKeywords);
    upsertMeta("robots", "index, follow");
    upsertLink("canonical", canonical);
  }, [pageTitle, metaTitle, metaDesc, metaKeywords, canonical]);

  useEffect(() => {
    if (!font) {
      return undefined;
    }
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = font;
    document.head.appendChild(link);
    return () => link.remove();
  }, [font]);

  return null;
};

export default SEO;
